module.exports = __webpack_public_path__ + "static/media/humpback.d83918bd.png";